import { Pipe, PipeTransform } from '@angular/core';
import { Agreement } from '@wilson/interfaces';

@Pipe({
  name: 'agreementsToText',
  standalone: true,
})
export class AgreementsToTextPipe implements PipeTransform {
  transform(agreements: Agreement[] | null, separator = ';'): string | null {
    if (!Array.isArray(agreements) || agreements.length === 0) {
      return null;
    }
    return agreements
      .map(
        (agreement) =>
          `${agreement.client?.name} - ${agreement.name}${agreement.costCenter ? `\n ${agreement.costCenter}` : ''}`,
      )
      .join(separator);
  }
}
